import { requiredString } from "components/form/utils";
import { z } from "zod";

export const budgetAllocationHourlySchema = z.object({
  department: requiredString(),
  grade: requiredString(),
  percentage: requiredString(),
});

export const budgetAllocationStandardSchema = z.object({
  department: requiredString(),
  grade: requiredString(),
  hours: requiredString(),
});
